import { Injectable, Input, Inject } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument, Query, CollectionReference } from 'angularfire2/firestore';

import { Http, Headers } from '@angular/http';
import { Subject, Observable } from 'rxjs/Rx';
import { TextSearch } from '../comum/textSearch';
import { Guid } from '../comum/helpers/system.guid';
import { Timestamp } from 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';


export const
    constVersao = '2018.11.15';


let userCorrente: any = null;

let __http: Http;

export function setHttp(_http) {
    __http = _http;
}


// tslint:disable-next-line:triple-equals
export interface IDataModel {
    id?: string;
    inativo?: boolean;
    dtatualiz?: Date;
    usuario?: string;
}

let db_prefix = 'nc-';
let config: any;
// o prefixo da coleção não é conhecido no APP
// chamar a função para obter o nome completo da coleção.
export function getTableNameFull(nomeBase: string) {
    return db_prefix + nomeBase;
}

export function getConfig() {
    return config;
}
export function setConfig(x) {
    config = x;
    db_prefix = x.db_prefix;
}
export function setTableNamePrefix(prefix) {
    config['db_prefix'] = prefix;
    db_prefix = prefix;
}


export class HttpModel {
    http: Http;


    constructor (private _http?: Http) {
        if (_http == null) {
            this.http = __http;
        } else {
            this.http = _http;
        }
    }

    getUrl(servico) {
        return getConfig().cloudUrl + servico;
    }

    header() {
        const h = new Headers();
        h.append('token', getConfig().token);
        if (config.Authorization) {
            h.append('Authorization', config.Authorization);
        }
        h.append('Access-Control-Allow-Origin', '*');
        h.append('Access-Control-Allow-Methods', 'GET,HEAD,PUT,PATCH,POST,DELETE');
        return h;
    }

    post(servico, data): Observable<any> {
        const url = this.getUrl(servico);
        return this.http.post(url, JSON.stringify(data), { headers: this.header() });
    }

    get(servico, params: string): Observable<any> {
        const url = this.getUrl(servico) + '?' + params;
        return this.http.get(url, { headers: this.header() });
    }


}


/// DataModel é uma classe base para acesso as coleções de dados
export class DataModel<T> {

    configDados: any;
    local_prefix: string = db_prefix;
    tableNameFull: string;
    fVerInativo = false;
    FItem: T;
    FDados: any = [];
    FModelDoc: AngularFirestoreCollection<T>;
    FDocRef;
    changedEvent = new Subject<T[]>();
    usuario = 'auto';
    // events
    onBeforeOpen = null;
    onAfterOpen = null;
    FUser: any;   // UserService.usuario;


    public static get versao() {
        return constVersao;
    }


    // validação
    static validate(item) {
        const x = {};
        for (const key in item) {
            // tslint:disable-next-line:triple-equals
            if ((key != 'id') && (key != 'actions')) {
                // retirar lixos e inconsistências
                if (item[key] != null) {
                    x[key] = item[key];
                }
            }
        }
        return x;
    }




    static toDate(dt): Date {
        const d: Date = this.strToDate(dt);
        const year = d.getFullYear();
        return new Date(year, d.getMonth(), d.getDate());
    }

    static strToDate(d): Date {
        const s: string = d.toString();
        if ((s).indexOf('Timestamp(') >= 0) {
            return d.toDate();
        }
        return new Date(s);
    }

    public static addDays(dt: Date, dias: number): Date {
        return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + dias);
    }

    public static toDateLocale(d) { /// ISO date to Date
        const x = this.strToDate(d),
            h = new Date();
        // tslint:disable-next-line:triple-equals
        if (x.toDateString() == h.toDateString()) {
            return 'hoje - ' + x.toLocaleTimeString();
        } else {
            return new Date(d.toDate()).toLocaleDateString();
        }
    }


    static calculateAge(birthday) { // birthday is a date
        const ageDifMs = Date.now() - birthday.getTime();
        const ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    static toDateAge(dt: Date): any {
        const d = this.strToDate(dt);

        // console.log(DataModel.calculateAge(d));
        const h = new Date();
        // console.log(dt,d,h,h.toDateString())
        // tslint:disable-next-line:triple-equals
        if (d.toDateString() == h.toDateString()) {
            return 'hoje as ' + d.toLocaleTimeString().substr(0, 5);
        } else {
            // return DataModel.calculateAge(d)
            return d.toLocaleDateString();
        }
    }

    set user(x) {
        this.FUser = x;
        if (x && x.email) {
            this.usuario = x.email;
        }
    }
    get user() {
        return this.FUser;
    }

    public static UsuarioCorrente() {
        return userCorrente;
    }

    public static setUsuarioCorrente(x) {
        userCorrente = x;
    }


    constructor (public dbConn: AngularFirestore,
        tableName: string) {
        this.user = userCorrente;
        this.tableNameFull = getTableNameFull(tableName);
        this.reset();
    }

    collectionName(coll: string) {
        this.tableNameFull = coll;
        return this;
    }




    newGuid(): any {
        return new Guid().toString();
    }

    // permite reenviar uma nova condição de filtro para os dados
    reset(refWhere?: any) {
        // atribui os parametros, sem executar;
        if (refWhere != null) {
            this.FModelDoc = this.dbConn.collection(this.tableNameFull,
                r => { this.FDocRef = refWhere(r); return this.FDocRef; });
        } else {
            this.FModelDoc = this.dbConn.collection(this.tableNameFull);
            this.FDocRef = this.FModelDoc.ref;
        }

        return this;
    }

    @Input()
    get verInativo() {
        return this.fVerInativo;
    }
    set verInativo(x: boolean) {
        this.fVerInativo = x;
        this.snapshot(
            r => r.where('inativo', '==', this.fVerInativo)
        );
    }


    /// recarregar os dados
    fetch() {
        this.snapshotChanges();
        return this;
    }

    // obter com base do stateChanges
    stateChanges(events: any[] = ['added']) {
        this.FModelDoc.stateChanges(events)
            .subscribe(
                d => {
                    this.FDados = d;
                    this.changedEvent.next([...this.FDados]);
                }
            );
    }

    emit() {
        if (this.FDados.length > 0) {
            this.changedEvent.next([...this.FDados]);
        }
    }

    collectionRef(tbl, where): CollectionReference {
        return this.dbConn.collection(tbl, where).ref;
    }

    // obter dados do servidor
    snapshot(procWhere: any, pSubscribe?: any, emit: boolean = true) {
        if (procWhere) {
            this.FDocRef = null;
            this.FModelDoc = this.dbConn.collection(this.tableNameFull,
                r => {
                    if (procWhere) {
                        this.FDocRef = procWhere(r);
                    } else {
                        this.FDocRef = r;
                    }
                    return this.FDocRef;
                }
            );
            if (this.FDocRef == null) { this.FDocRef = this.FModelDoc.ref; }
        } else {
            this.FDocRef = null;
            this.FDocRef = this.dbConn.collection(this.tableNameFull).ref;
        }
        this.openQuery(this.FDocRef, r => {
            this.FDados = r;
            if (emit) {
                this.changedEvent.next([...this.FDados]);
            }
            if (pSubscribe != null) {
                pSubscribe(this.FDados);
            }
        });
        return this;
    }

    one(procWhere?: any, pSubscribe?: any, emit: boolean = true) {
        return this.snapshot(r => {
            let rt = r;
            if (procWhere) {
                rt = procWhere(r);
            }
            return rt.limit(1);
        }, pSubscribe, emit);
    }

    openDoc(id: string, pSubscribe) {
        const qry = this.dbConn.collection(this.tableNameFull).doc(id);
        qry.ref.onSnapshot(doc => {
            const dados = doc.data();
            dados.id = doc.id;
            if (pSubscribe) { pSubscribe(dados); }
        });
    }

    openQuery(queryRef, pSubscribe, pErro?) {
        queryRef.onSnapshot(docs => {
            const rt = [];
            docs.forEach(element => {
                const dados = element.data();
                dados.id = element.id;
                rt.push(dados);
            });
            // tslint:disable-next-line:triple-equals
            if (docs.length == 0) {
                if (pErro) {
                    pErro(new Error('Não havia itens para retornar'));
                }
            }
            if (pSubscribe != null) {
                pSubscribe(rt);
            }
        }, pErro);

        return this;
    }


    // obter dados do servidor
    snapshotChanges(pSubscribe?, emit: boolean = true) {
        return this.snapshot(null, pSubscribe, emit);
    }

    // async metodo para obter dados do servidor
    valueChanges() {
        this.FDocRef.valueChanges()
            .subscribe(d => {
                this.FDados = d;
                this.changedEvent.next([...this.FDados]);
            });
        return this;
    }

    then(p) {
        return this.FDocRef.get().then(r => {
            return [...r.data()];
        });
    }

    // reenvia uma nova condição de seleção ao dados.
    whereRef(field, conditions, value, restart: boolean = false): Query {
        // nao funcionou
        if (restart) { this.reset(); }
        return this.FModelDoc.ref.where(String(field), conditions, value);

    }

    where(field, conditions, value, restart: boolean = false): Query {
        // nao funcionou
        if (restart) { this.reset(); }
        return this.FModelDoc.ref.where(String(field), conditions, value);

    }


    // tenta fazer um upset do registro   Insert or Update
    post(item: any, proc?: any, errProc?: any): Promise<any> {
        let rt;
        if (item.inativo == null) {
            item.inativo = false;
        }
        // console.log('post:', item);
        if (item.id && item.id > '') {
            rt = this.updateOrInsert(item.id, item, proc, errProc);
        } else {
            rt = this.add(item, proc, errProc);
        }
        return rt;
    }

    // apaga um dado do servidor
    delete(id, item = null, proc?: any, errProc?: any) {
        if (item == null) {
            item = {};
        }
        item.inativo = true;
        item.dtInativo = new Date();
        if (item.usuario === null) {
            item.usuario = this.usuario;
        }
        const rt = this.dbConn.doc(this.tableNameFull + '/' + id).update(item);
        rt.then(done => {
            if (proc != null) {
                proc(done);
                this.dataLogs(this.tableNameFull, 'inativo', item);
            }
        }).catch(err => {
            if (errProc != null) { errProc(err); }
        });
        return rt;
    }



    // apaga um dado do servidor
    deleteRow(id, proc?: any, errProc?: any) {
        const rt = this.dbConn.doc(this.tableNameFull + '/' + id).delete();
        rt.then(done => {
            if (proc != null) {
                proc(done);
                this.dataLogs(this.tableNameFull, 'deleteRow', { documentId: id });
            }
        }).catch(err => {
            if (errProc != null) { errProc(err); }
        });
        return rt;
    }


    /// atualiza dados já existentes
    update(id, item, proc?: any, errProc?: any): Promise<void> {
        item.usuario = this.usuario;
        item.dtatualiz = new Date();
        const vItem = item;
        delete vItem.id;
        const rt = this.dbConn.doc(this.tableNameFull + '/' + id).update(DataModel.validate(vItem));
        rt.then(done => {
            if (proc != null) { proc(done); }
            this.dataLogs(this.tableNameFull, 'update', vItem);
        })
            .catch(err => {
                if (errProc != null) {
                    errProc(err);
                }
            });
        return rt;
    }

    async updateOrInsert(id, item, proc?: any, erroProc?: any, merge: boolean = true) {
        // console.log(id,item);
        item.usuario = this.usuario;
        item.dtatualiz = new Date();
        let vItem: any = {};
        vItem = Object.assign(vItem, DataModel.validate(item));
        delete vItem.id;
        const rt = this.dbConn.collection(this.tableNameFull)
            .doc(id).set(vItem, { merge: merge });
        rt.then(done => {
            if (proc != null) { proc(done); }
            this.dataLogs(this.tableNameFull, 'updateOrInsert', vItem);
        })
            .catch(err => {
                if (erroProc != null) { erroProc(err); }
            });
        return rt;
    }

    dataLogs(tab, operacao, item) {
        const dt = new Date();
        const d = dt.getFullYear() + '-' + dt.getMonth() + '-' + dt.getDate();
        item.operacao = operacao;
        this.dbConn.collection('dataLogs').doc(d).collection(tab).add(item);
    }

    /*  usar   collectionRef
    collection(tableName: string): AngularFirestoreCollection {
       return this.dbConn.collection(tableName);
    }
    */


    /// adicionar dados a coleção
    add(item, proc?: any, errProc?: any): Promise<any> {

        if (item !== null) {
            item.usuario = this.usuario;
            item.dtatualiz = new Date();
            const vItem = DataModel.validate(item);
            // console.log('add:', vItem);
            const rt = this.dbConn.collection(this.tableNameFull).add(vItem);
            rt.then(done => {
                if (proc != null) { proc(done); }
                this.dataLogs(this.tableNameFull, 'add', vItem);
            }).catch(
                err => {
                    if (errProc != null) { errProc(err); }
                }
            );
            return rt;
        } else { return null; }
    }

    // envia uma lista de dados ARRAY para o servidor
    addList(items, proc?: any, errProc?: any) {
        // console.log('Descarregando lista de analytics');
        items.forEach(element => {
            this.post(element, proc, errProc);
        });
        return this;
    }

    // obter o número seguinte de uma sequencia.
    getNewID(nome: string, proc) {
        const x = 1;
        const tab = 'ctrl_id';
        nome = TextSearch.clear(nome);  // retira caracteres nao permitidos

        const rt = new HttpModel().get('/gerarSequencia', 'id=' + nome);
        rt.subscribe(rsp => {
            const r = JSON.parse(rsp._body);
            // console.log(r);
            r.valor = r.value;
            proc(r);
            return r;
        });
    }

}
